'use client';

import { type FC, useMemo } from 'react';

import { useMediaQuery } from '../../hooks/use-media-query';
import { PopoverFloatingContext } from './context/popover-floating.context';
import { PopoverRootContext } from './context/popover-root.context';
import { usePopover } from './hooks/use-popover';
import type { PopoverRootPropsInterface } from './types/popover-root.types';

/**
 * @since 10.0.0
 */
export const PopoverRoot: FC<PopoverRootPropsInterface> = (props: PopoverRootPropsInterface) => {
  const { children, modal = true, tone = 'neutral', dividers = true, ...rest } = props;
  const { popover, floating } = usePopover(rest);
  // TODO: replace with something reusable
  const isSmallBreakpoint = useMediaQuery('only screen and (max-width : 30em)');
  const contextValue = useMemo(
    () => ({ popover, modal: modal && isSmallBreakpoint, tone, dividers }),
    [popover, modal, isSmallBreakpoint, tone, dividers],
  );
  return (
    <PopoverRootContext.Provider value={contextValue}>
      <PopoverFloatingContext.Provider value={floating}>{children}</PopoverFloatingContext.Provider>
    </PopoverRootContext.Provider>
  );
};

PopoverRoot.displayName = 'Popover.Root';
